import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { apiClient } from "../../config/apiClient";
import { API } from "../../config/apiConfig";
import { CreateCustomizationPayload, OrgAppParams } from "./NetTypes";

async function createCustomizationRequest({ orgId, appId, data }: CreateCustomizationPayload) {
	return await apiClient
		.post(API.COMMAND.ORGANIZATIONS.CUSTOMIZATION(orgId, appId), data, {
			headers: {
				"Content-Type": "multipart/form-data"
			}
		})
		.then((res) => res.data);
}

export function useCreatAppCustomization(params: OrgAppParams) {
	return useMutation<any, AxiosError, FormData>({
		mutationFn: (data: FormData) => createCustomizationRequest({ ...params, data })
	});
}
